import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, List } from "antd";
import {
  AiOutlineCalendar,
  AiOutlineGoogle,
  AiFillWindows,
} from "react-icons/ai";
import { FaYahoo } from "react-icons/fa";
import { BiDownload } from "react-icons/bi";
import { t } from "i18next";
import { google, outlook, office365, yahoo } from "calendar-link";
import {
  apisUrl,
  matchUrl,
  renderResponsable,
  renderUserName,
} from "../../../utils/constants";

const DownloadICS = ({ type = "button" }) => {
  const { prestation } = useSelector(state => state.prestation);
  const [visible, setVisible] = useState(false);

  if (!prestation?.intervention) return null;

  const {
    startDate,
    endDate,
    location,
    type: interventionType,
    extra,
    linkVisio,
    phone,
  } = prestation.intervention;

  const { applicant, responsable } = prestation;

  const reference = prestation.reference || "";
  const title = `SOS Ticino – Derman - ${reference}`;

  let resp = null;

  if (responsable.firstname || responsable.lastname) {
    resp = `${renderResponsable(responsable)}`;

    if (responsable.phone) {
      resp += ` (${responsable.phone})`;
    }
  }

  const currentUrl = window.location.href;

  const matchedUrl = apisUrl.find(api => matchUrl(currentUrl, api.match));

  const url = `${matchedUrl?.public}prestations/${prestation._id}`;

  const description =
    `${title}\n` +
    `${t("prestationResumeCards.serviceType")} : ${t(
      `interventionType.${interventionType}`,
    )}\n` +
    `${extra ? `${extra}\n` : ""}` +
    `${startDate ? `${new Date(startDate).toLocaleString()}\n` : ""}` +
    `${endDate ? `${new Date(endDate).toLocaleString()}\n` : ""}` +
    // `${interventionType === "phone" && phone ? `📞 ${phone}\n` : ""}` +
    `${interventionType === "visio" && linkVisio ? `🔗 ${linkVisio}\n` : ""}` +
    `${`🔗 ${url}\n`}` +
    `${
      interventionType === "in_person" && location ? `📍 ${location}\n` : ""
    }` +
    `${t("prestationResumeCards.applicant")} : ${renderUserName(applicant)} ${
      applicant.email ? `(${applicant.email})` : ""
    }\n` +
    `
    ${
      resp ? `${t("prestationResumeCards.responsiblePersonnel")} ${resp}\n` : ""
    }
  `;

  // npx puppeteer browsers install chrome

  const event = {
    title,
    description,
    start: new Date(startDate).toISOString(),
    end: new Date(endDate).toISOString(),
    location: interventionType === "in_person" ? location : undefined,
    url,
  };

  const createICS = () => {
    const dtStart =
      new Date(startDate)
        .toISOString()
        .replace(/[-:]|\.\d{3}/g, "")
        .slice(0, -1) + "Z";
    const dtEnd =
      new Date(endDate)
        .toISOString()
        .replace(/[-:]|\.\d{3}/g, "")
        .slice(0, -1) + "Z";

    return `BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nSUMMARY:${title} - (${reference})\nDESCRIPTION:${description.replace(
      /\n/g,
      "\\n",
    )}\nDTSTART:${dtStart}\nDTEND:${dtEnd}\n${
      location ? `LOCATION:${location}\n` : ""
    }URL:${url}\nEND:VEVENT\nEND:VCALENDAR`;
  };

  const calendarOptions = [
    {
      label: "Google",
      icon: <AiOutlineGoogle size={18} />,
      url: google(event),
    },
    {
      label: "Outlook",
      icon: <AiFillWindows size={18} />,
      url: outlook(event),
    },
    {
      label: "Office365",
      icon: <AiFillWindows size={18} />,
      url: office365(event),
    },
    {
      label: "Yahoo",
      icon: <FaYahoo size={18} />,
      url: yahoo(event),
    },
    {
      label: ".ICS",
      icon: <BiDownload size={18} />,
      action: () => {
        const blob = new Blob([createICS()], { type: "text/calendar" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${reference || "event"}.ics`;
        a.click();
        URL.revokeObjectURL(url);
      },
    },
  ];

  const modalContent = (
    <List
      size="small"
      dataSource={calendarOptions}
      renderItem={item => (
        <List.Item
          onClick={() => {
            if (item.url) {
              window.open(item.url, "_blank", "noopener,noreferrer");
            } else if (item.action) {
              item.action();
            }
            setVisible(false);
          }}
          style={{ cursor: "pointer" }}
        >
          <span style={{ marginRight: 8 }}>{item.icon}</span>
          {item.label}
        </List.Item>
      )}
    />
  );

  const handleClick = () => setVisible(true);

  const trigger =
    type === "link" ? (
      <a onClick={handleClick}>
        <span style={{ marginLeft: 5, marginRight: 10 }}>
          <AiOutlineCalendar size={15} />
        </span>
        {t("prestationAction.addToMyCalendar")}
      </a>
    ) : (
      <Button
        onClick={handleClick}
        type="primary"
        className="confirmButton forceRed"
        size="large"
      >
        <AiOutlineCalendar style={{ marginRight: 8 }} />
        {t("prestationAction.addToMyCalendar")}
      </Button>
    );

  return (
    <>
      {trigger}
      <Modal
        open={visible}
        title={t("prestationAction.chooseCalendar")}
        footer={null}
        onCancel={() => setVisible(false)}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default DownloadICS;
